module.exports = __webpack_public_path__ + "img/3.a25a82df.jpg";